import axios from "axios";
import JSZip from "jszip";

export async function getAircareData(remoteUrl) {
  const endpoint = `${remoteUrl}/api/app/com.lge.ai.aircaretest/test`;
  try {
    const res = await axios.get(endpoint, { params: { type: "demo" } });
    console.log("getAircareData res:", res.data);
    return res.data;
  } catch (error) {
    console.error("getAircareData err:", error.response?.data || error.message);
    throw error;
  }
}

export async function getWeatherData(remoteUrl) {
  const endpoint = `${remoteUrl}/api/app/com.lge.enc/weather`;
  try {
    const res = await axios.get(endpoint);
    console.log("getWeatherData res:", res.data);
    return res.data;
  } catch (error) {
    console.error("getWeatherData err:", error.response?.data || error.message);
    throw error;
  }
}

export async function downloadAndExtractZip(zipUrl) {
  try {
    const res = await axios.get(zipUrl, {
      responseType: "arraybuffer",
    });
    const zip = await JSZip.loadAsync(res.data);
    const extractedFiles = {};
    for (const fileName of Object.keys(zip.files)) {
      const file = zip.files[fileName];
      const content = await file.async("string");
      try {
        extractedFiles[fileName] = JSON.parse(content);
      } catch {
        extractedFiles[fileName] = content;
      }
    }
    console.log("downloadAndExtractZip res:", extractedFiles);
    return extractedFiles;
  } catch (err) {
    console.error("downloadAndExtractZip err:", err);
    throw err;
  }
}

export function getCO2Level(value) {
  if (value <= 700) return { level: "좋음", color: "#10b981" };
  if (value <= 1000) return { level: "보통", color: "#fbbf24" };
  if (value <= 1500) return { level: "나쁨", color: "#f97316" };
  return { level: "매우나쁨", color: "#ef4444" };
}
 
export function getPMLevel(value) {
  if (value <= 15) return { level: "좋음", color: "#10b981" };
  if (value <= 35) return { level: "보통", color: "#fbbf24" };
  if (value <= 75) return { level: "나쁨", color: "#f97316" };
  return { level: "매우나쁨", color: "#ef4444" };
}

export function getRHLevel(value) {
  if (value < 20) return { level: "매우건조", color: "#ef4444"};
  if (value < 30) return { level: "건조", color: "#f97316" };
  if (value > 80) return { level: "매우습함", color: "#ef4444" };
  if (value > 70) return { level: "습함", color: "#f97316" };
  if (value < 40 || value > 60) return { level: "보통", color: "#fbbf24" };
  return { level: "좋음", color: "#10b981" };
}

export function getTempLevel(value) {
  if (value < 22) return { level: "낮음", color: "#3b82f6" };
  if (value <= 26) return { level: "적절", color: "#10b981" };
  return { level: "높음", color: "#ef4444" };
}